// extracted by mini-css-extract-plugin
module.exports =  {"tag":"TagDefault-module__tag___KJMx7"};